import React, { ReactNode, useRef, useState } from 'react'
import { debounce } from "../../utils"
import useClickOutside from '../../utils/hooks/useClickOutSide'
import Loading from './Loading'

interface IProps {
    onChange?: (value: string) => void
    onSearch?: (value: string) => void
    onScrollHitBottom?: () => void
    onClickOutSide?: () => void
    onClear?: () => void
    loading?: boolean
    autoFocus?: boolean
    register?: IUserSearch
    debounceTime?: number,
    data: Array<any>
    placeholder?: string
    dropdownData: (data: any, onSelect: () => void) => ReactNode
}

interface IState {
    show: boolean,
}

const initState: IState = {
    show: true,
}

const Search = (props: IProps) => {
    const {
        onSearch,
        onChange,
        data = [],
        autoFocus = true,
        onClear,
        register,
        onClickOutSide,
        debounceTime = 500,
        loading = false,
        placeholder = 'Tìm kiếm nhà thuốc',
        dropdownData,
        onScrollHitBottom
    } = props

    const searchRef: any = useRef()
    const inputSearch: any = useRef()

    const [state, setState] = useState<IState>(initState)

    const handleSeach = debounce((value: string) => {
        if (onSearch) {
            onSearch(value)
        }
    }, debounceTime)

    const resetState = () => {
        inputSearch.current.value = ''
        setState({
            show: false,
        })
    }

    /**
     * Clear input on selected
     */
    const onSelect = () => {
        resetState();
    }

    useClickOutside(() => {
        setState(prev => ({ ...prev, show: false }))
    }, [searchRef])

    const handleScroll = (e: any) => {
        if (loading) return
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight

        if (bottom) {
            if (onScrollHitBottom) {
                onScrollHitBottom()
            }
        }
    }

    if (register) {
        register.hide = () => {
            setState((prev) => ({ ...prev, show: false }))
        }
        register.show = () => {
            setState((prev) => ({ ...prev, show: true }))
        }
        register.setValue = (value: string) => {
            inputSearch.current.value = value
            handleSeach(value)
        }
        register.getValue = () => inputSearch.current.value
    }

    return <div className="search-component" ref={searchRef}>
        <div className="form-search">
            <form id="search">
                <input
                    autoFocus={autoFocus}
                    ref={inputSearch}
                    onClick={() => setState(prev => ({ ...prev, show: true }))}
                    type="text"
                    name="search"
                    placeholder={placeholder}
                    className="input-search"
                    onChange={(e => {
                        e.preventDefault()
                        const { value } = e?.target
                        handleSeach(value)
                    })}
                />

                <span id="btn-search-clear" onClick={() => {
                    resetState()
                    if (onClear) {
                        onClear()
                    }
                }}>
                    {
                        loading ?
                            <Loading /> :
                            <img src="./images/cancel.svg" title="Xóa" className="img-fluid" width={24} />
                    }
                </span>

                <button type="button" className="btn-search">
                    <img src="./images/search.svg" title="Tìm kiếm" className="img-fluid" width={24} />
                </button>
            </form>
            {
                data.length !== 0 && state.show && <div className="search-results">
                    <ul onScroll={handleScroll} style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {dropdownData && dropdownData(data, onSelect)}
                    </ul>
                </div>
            }
        </div>
    </div>
}

export default Search

interface IUserSearch {
    hide: () => void
    show: () => void
    setValue: (value: string) => void
    getValue: () => string
}

export const useSearch = () => {
    const ref = useRef<IUserSearch>({
        hide: () => { },
        show: () => { },
        setValue: () => { },
        getValue: () => '',
    })

    return ref.current
}